type ComparablePrimitive = string | number | boolean;
type SupportedValue = ComparablePrimitive | null | undefined;

export function areArraysEqualIgnoreOrder(
  arr1: SupportedValue[] | null | undefined,
  arr2: SupportedValue[] | null | undefined,
) {
  if (arr1 == null && arr2 == null) {
    return true;
  }

  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false;
  }

  const filteredArr1 = arr1.filter(isComparablePrimitive);
  const filteredArr2 = arr2.filter(isComparablePrimitive);

  if (filteredArr1.length !== filteredArr2.length) {
    return false;
  }

  const valueCounts = new Map<ComparablePrimitive, number>();

  for (const value of filteredArr1) {
    valueCounts.set(value, (valueCounts.get(value) ?? 0) + 1);
  }

  for (const value of filteredArr2) {
    const count = valueCounts.get(value);

    if (count === undefined) {
      return false;
    }

    if (count === 1) {
      valueCounts.delete(value);
    } else {
      valueCounts.set(value, count - 1);
    }
  }

  return valueCounts.size === 0;
}

function isComparablePrimitive(value: SupportedValue): value is ComparablePrimitive {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === "number" && Number.isNaN(value)) {
    return false;
  }

  return true;
}
